export default __webpack_public_path__ + "static/media/app_store.bd9f310f.svg";